// single pages
import homePage from '../pages/Home.vue'
import schmuckstueckePage from '../pages/schmuckstuecke/SchmuckstueckePage'
import goldschmiedePage from '../pages/goldschmiede/GoldschmiedePage'
import individuellesPage from '../pages/individuelles/IndividuellesPage'
import individuellesDetailPage from '../pages/individuellesDetail/IndividuellesDetailPage'
import impressumPage from '../pages/impressum/ImpressumPage'
import individuellGallery from '../pages/indivuellGallery/IndividuellesGallery'
import notFoundPage from '../pages/NotFound.vue'

import { armschmuckDB, kettenDB, manschettenknoepfeDB, ohrringeDB, ringeDB } from '@/assets/gallery'
import { anfertigungenText, eheringeText, reparaturenText } from '@/assets/text/individuelles'

export const routes = [
  {
    path: '/',
    name: 'index',
    component: homePage,
    meta: {
      title: 'Goldschmiede Goldregen München – Handgefertigter Schmuck & Ladenwerkstatt',
      description: 'Goldschmiede Goldregen – Ihre Ladenwerkstatt für handgefertigten Schmuck in München-Schwabing. Individuelle Ringe, Ketten, Ohrringe, Eheringe & Schmuckreparaturen.'
    }
  },
  {
    path: '/schmuckstuecke',
    name: 'schmuckstuecke',
    component: schmuckstueckePage,
    meta: {
      title: 'Schmuckstücke – Handgefertigter Goldschmuck | Goldschmiede Goldregen',
      description: 'Entdecken Sie unsere handgefertigten Schmuckstücke: Ringe, Ketten, Ohrringe, Armschmuck und Manschettenknöpfe aus unserer Münchner Werkstatt.'
    }
  },
  {
    path: '/goldschmiede',
    name: 'goldschmiede',
    component: goldschmiedePage,
    meta: {
      title: 'Unsere Goldschmiede in München-Schwabing | Goldschmiede Goldregen',
      description: 'Unsere Ladenwerkstatt in München-Schwabing: Erleben Sie das traditionsreiche Goldschmiedehandwerk hautnah. Alle Schmuckstücke werden vor Ort von Hand gefertigt.'
    }
  },
  {
    path: '/individuelles',
    name: 'individuelles',
    component: individuellesPage,
    meta: {
      title: 'Individueller Schmuck nach Maß – Anfertigungen & Umarbeitungen | Goldregen',
      description: 'Individuelle Schmuckanfertigungen nach Ihren Wünschen. Eheringe, Umarbeitungen und Reparaturen – auch mit Ihrem Altgold. Goldschmiede Goldregen München.'
    }
  },
  {
    path: '/individuelles/eheringe',
    name: 'individuellesEheringe',
    component: individuellesDetailPage,
    meta: {
      title: 'Individuelle Eheringe vom Goldschmied | Goldschmiede Goldregen München',
      description: 'Einzigartige Eheringe, individuell handgefertigt in unserer Münchner Goldschmiede. Persönliche Beratung und Anfertigung nach Ihren Vorstellungen.'
    },
    props: {
      title: 'Individuelle Eheringe',
      text: eheringeText,
      imgName: require('@/assets/imgs/individuelles_eheringe.jpg')
    }
  }, {
    path: '/individuelles/anfertigung',
    name: 'individuellesAnfertigung',
    component: individuellesDetailPage,
    meta: {
      title: 'Schmuck-Anfertigung nach Maß | Goldschmiede Goldregen München',
      description: 'Individuelle Schmuckanfertigungen nach Ihren Wünschen. Vom Entwurf bis zum fertigen Stück – handgefertigt in München-Schwabing.'
    },
    props: {
      title: 'Anfertigung',
      text: anfertigungenText,
      imgName: require('@/assets/imgs/individuelles_anfertigung.jpg')
    }
  }, {
    path: '/individuelles/reparaturen',
    name: 'individuellesReparaturen',
    component: individuellesDetailPage,
    meta: {
      title: 'Schmuckreparaturen & Umarbeitungen | Goldschmiede Goldregen München',
      description: 'Professionelle Schmuckreparaturen und Umarbeitungen in München. Wir hauchen Ihrem Schmuck neues Leben ein – auch mit Altgold.'
    },
    props: {
      title: 'Reparaturen',
      text: reparaturenText,
      imgName: require('@/assets/imgs/individuelles_reparaturen.jpg')
    }
  },
  {
    path: '/schmuckstuecke/ringe',
    name: 'gallerieRinge',
    component: individuellGallery,
    meta: {
      title: 'Handgefertigte Ringe – Galerie | Goldschmiede Goldregen München',
      description: 'Galerie handgefertigter Ringe aus Gold und Edelsteinen. Jedes Stück ein Unikat aus unserer Münchner Goldschmiede.'
    },
    props: {
      name: 'Ringe',
      imgObject: ringeDB
    }
  }, {
    path: '/schmuckstuecke/armschmuck',
    name: 'gallerieArmschmuck',
    component: individuellGallery,
    meta: {
      title: 'Armschmuck – Armbänder & Armreife | Goldschmiede Goldregen München',
      description: 'Handgefertigter Armschmuck: Armbänder und Armreife aus Gold. Entdecken Sie unsere Kollektion aus der Goldschmiede Goldregen.'
    },
    props: {
      name: 'Armschmuck',
      imgObject: armschmuckDB
    }
  }, {
    path: '/schmuckstuecke/ketten',
    name: 'gallerieKetten',
    component: individuellGallery,
    meta: {
      title: 'Goldketten & Colliers – Galerie | Goldschmiede Goldregen München',
      description: 'Handgefertigte Goldketten und Colliers aus unserer Ladenwerkstatt in München-Schwabing. Jedes Stück ein Unikat.'
    },
    props: {
      name: 'Ketten',
      imgObject: kettenDB
    }
  }, {
    path: '/schmuckstuecke/ohrringe',
    name: 'gallerieOhrringe',
    component: individuellGallery,
    meta: {
      title: 'Ohrringe – Handgefertigter Ohrschmuck | Goldschmiede Goldregen München',
      description: 'Handgefertigte Ohrringe aus Gold und Edelsteinen. Entdecken Sie unsere Ohrschmuck-Kollektion aus der Goldschmiede Goldregen.'
    },
    props: {
      name: 'Ohrringe',
      imgObject: ohrringeDB
    }
  }, {
    path: '/schmuckstuecke/manschettenknoepfe',
    name: 'gallerieManschettenknoepfe',
    component: individuellGallery,
    meta: {
      title: 'Manschettenknöpfe aus Gold | Goldschmiede Goldregen München',
      description: 'Handgefertigte Manschettenknöpfe aus Gold – einzigartige Accessoires aus unserer Münchner Goldschmiede.'
    },
    props: {
      name: 'Manschettenknöpfe',
      imgObject: manschettenknoepfeDB
    }
  },
  {
    path: '/impressum',
    name: 'impressum',
    component: impressumPage,
    meta: {
      title: 'Impressum | Goldschmiede Goldregen München',
      description: 'Impressum der Goldschmiede Goldregen in München-Schwabing.'
    }
  },
  {
    path: '*',
    component: notFoundPage,
    meta: {
      title: 'Seite nicht gefunden | Goldschmiede Goldregen',
      description: 'Die gesuchte Seite wurde leider nicht gefunden.'
    }
  }
]
